// extracted by mini-css-extract-plugin
module.exports = {"VerbalWarningAckDoc":"VerbalWarningAck_VerbalWarningAckDoc__3Hh5k"};